import { useEffect } from "react";
import { observer } from "mobx-react";
import { useStores } from "../hooks";
import { MenuType } from "../services/menu/models";
import CartPage from "./cart";
import RestifyLoader from "./restifyLoader";
import CartDesktopPage from "./cartDesktop";


const MenuTypeCartWrapper = () => {

    const { generalMenuStore, generalStore, menuStore, isInited } = useStores();
    useEffect(() => {

        if(!isInited) return;
        if (generalMenuStore.type !== MenuType.none) return;
        (async () => {
            await generalMenuStore.getMenuTypeByMenuId(generalStore.menuId)
            await menuStore.init({
                    menuId: generalStore.menuId,
                    organizationId: generalStore.organizationId,
                    organizationBranchId: generalStore.organizationBranchId
                }
            )
            generalMenuStore.setMenu(menuStore.menu);
        })();

    }, [generalMenuStore.type, isInited]);

    return <>
        <RestifyLoader
            show={!generalMenuStore.menu}
        />
        {(generalMenuStore.type === MenuType.regular && window.screen.width < 700) &&
            <CartPage/>
        }
        {(generalMenuStore.type === MenuType.regular && window.screen.width >= 700) &&
			<CartDesktopPage/>
        }
    </>
}

export default observer(MenuTypeCartWrapper)
